import ForgetPassword from "../../components/Auth/ForgetPassword";

function ForgetPasswordPage() {
  return (
    <div>
        <ForgetPassword />
    </div>
  );
}

export default ForgetPasswordPage;